class StickyBar {
  constructor() {
    // Mode 1 Elements (Product Page)
    this.atcAddBtn = document.getElementById('StickyATC-Add');
    this.atcBuyBtn = document.getElementById('StickyATC-Buy');
    
    // Mode 2 Elements (Other Pages)
    this.summaryBar = document.getElementById('StickySummary');
    this.countEl = document.getElementById('StickySummaryCount');
    this.subtotalEl = document.getElementById('StickySummarySubtotal');

    this.init();
  }

  init() {
    // If we are on a Product Page, bind the Sticky ATC buttons
    if (this.atcAddBtn && this.atcBuyBtn) {
      this.bindStickyATC();
    }

    // If we are on any other page, listen for cart updates
    if (this.summaryBar) {
      this.currencySymbol = this.summaryBar.dataset.currencySymbol || '$';
      // Ensure these functions exist in your broader code, or this will throw an error
      if (typeof this.initFetchInterceptor === 'function') this.initFetchInterceptor();
      document.addEventListener('cart:updated', () => {
        if (typeof this.fetchLatestCartData === 'function') this.fetchLatestCartData();
      });
    }
  }

  /* --- PRODUCT PAGE LOGIC --- */
  bindStickyATC() {
    // Broadened selector to catch more Shopify form variations
    const mainForm = document.querySelector('form[action^="/cart/add"], .product-form form, form.product-form');

    // Add to Cart Button Logic
    this.atcAddBtn.addEventListener('click', (e) => {
      e.preventDefault();
      
      if (!mainForm) {
        console.error('StickyBar: Product form not found.');
        return;
      }

      // Look for the original button. If it's there, click it. 
      const mainSubmitBtn = mainForm.querySelector('button[type="submit"][name="add"], button.product-form__submit, input[type="submit"][name="add"]');
      
      if (mainSubmitBtn) {
        mainSubmitBtn.click(); 
      } else {
        // FALLBACK: Manually send the data via AJAX
        const oldText = this.atcAddBtn.textContent;
        this.atcAddBtn.textContent = 'Adding...';
        this.atcAddBtn.disabled = true; // Prevent double clicks
        
        const formData = new FormData(mainForm);
        
        // Safely determine the root route (prevents crashes if window.Shopify is missing)
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
            ? window.Shopify.routes.root 
            : '/';

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest' // Required by Shopify AJAX API
          }
        })
        .then(res => {
          if (!res.ok) throw new Error('Network response was not ok');
          return res.json();
        })
        .then(data => {
          // Redirect straight to the cart page
          window.location.href = rootUrl + 'cart';
        })
        .catch(err => {
          console.error('StickyBar Add to Cart Error:', err);
          this.atcAddBtn.textContent = oldText;
          this.atcAddBtn.disabled = false;
        });
      }
    });

    // Buy Now Button Logic
    this.atcBuyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      
      if (mainForm) {
        // Remove any existing return_to inputs to prevent duplicates on multiple clicks
        const existingInput = mainForm.querySelector('input[name="return_to"]');
        if (existingInput) {
          existingInput.remove();
        }

        // Add hidden input to redirect straight to checkout
        const returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        returnInput.value = '/checkout';
        mainForm.appendChild(returnInput);
        
        mainForm.submit();
      } else {
        console.error('StickyBar: Product form not found for Buy Now action.');
      }
    });
  }
}

// IMPORTANT: Ensure the class is instantiated after the DOM has fully loaded
document.addEventListener('DOMContentLoaded', () => {
  new StickyBar();
});